"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.create = exports.getInput = void 0;
var common_sidecar_1 = require("../../../main/common-sidecar");
var rogueGamepad_1 = require("./rogueGamepad");
var _input = null;
var getInput = function () {
    if (!_input) {
        _input = {
            left: rogueGamepad_1.InputState.StaleUp,
            right: rogueGamepad_1.InputState.StaleUp,
            middle: rogueGamepad_1.InputState.StaleUp,
            nextLeft: rogueGamepad_1.InputState.StaleUp,
            nextRight: rogueGamepad_1.InputState.StaleUp,
            nextMiddle: rogueGamepad_1.InputState.StaleUp,
        };
    }
    return _input;
};
exports.getInput = getInput;
var create = function () {
    var s = common_sidecar_1.common.getPhaserScene();
    s.input.mouse.disableContextMenu();
    s.input.on('pointerdown', function (pointer) {
        // console.log('pointerdown', pointer)
        var input = (0, exports.getInput)();
        if (pointer.leftButtonDown()) {
            input.nextLeft = rogueGamepad_1.InputState.JustDown;
        }
        if (pointer.rightButtonDown()) {
            input.nextRight = rogueGamepad_1.InputState.JustDown;
        }
        if (pointer.middleButtonDown()) {
            input.nextMiddle = rogueGamepad_1.InputState.JustDown;
        }
    });
    s.input.on('pointerup', function (pointer) {
        // console.log('pointerup', pointer)
        var input = (0, exports.getInput)();
        if (pointer.leftButtonReleased()) {
            input.nextLeft = rogueGamepad_1.InputState.JustUp;
        }
        if (pointer.rightButtonReleased()) {
            input.nextRight = rogueGamepad_1.InputState.JustUp;
        }
        if (pointer.middleButtonReleased()) {
            input.nextMiddle = rogueGamepad_1.InputState.JustUp;
        }
    });
};
exports.create = create;
var update = function () {
    var input = (0, exports.getInput)();
    input.left = input.nextLeft;
    input.right = input.nextRight;
    input.middle = input.nextMiddle;
    var reset = function (key) {
        if (input[key] === rogueGamepad_1.InputState.JustDown) {
            input[key] = rogueGamepad_1.InputState.StaleDown;
        }
        if (input[key] === rogueGamepad_1.InputState.JustUp) {
            input[key] = rogueGamepad_1.InputState.StaleUp;
        }
    };
    reset('nextLeft');
    reset('nextRight');
    reset('nextMiddle');
};
exports.update = update;
